export default interface FormField {
  label: string;
  valueField: string;
  type: FormFieldType;
  required?: boolean;
  options?: any[];
}

export enum FormFieldType {
  TEXT,
  TEXTAREA,
  NUMBER,
  CHECKBOX,
  RADIO,
  SELECT,
  COMBO,
  TAGS,
  DATE,
  LABEL,
}
